// ACTIONS
export const FETCH = 'offerzen/workHistory/FETCH'
const FETCH_SUCCESS = 'offerzen/workHistory/FETCH_SUCCESS'

export const DELETE = 'offerzen/workHistory/DELETE'
const DELETE_SUCCESS = 'offerzen/workHistory/DELETE_SUCCESS'
const DELETE_ERROR = 'offerzen/workHistory/DELETE_ERROR'

export const CREATE = 'offerzen/workHistory/CREATE'
const CREATE_SUCCESS = 'offerzen/workHistory/CREATE_SUCCESS'
const CREATE_ERROR = 'offerzen/workHistory/CREATE_ERROR'

export const UPDATE = 'offerzen/workHistory/UPDATE'
const UPDATE_SUCCESS = 'offerzen/workHistory/UPDATE_SUCCESS'
const UPDATE_ERROR = 'offerzen/workHistory/UPDATE_ERROR'

const ADD_TEMP_ITEM = 'offerzen/workHistory/ADD_TEMP_ITEM'
const DELETE_TEMP_ITEM = 'offerzen/workHistory/DELETE_TEMP_ITEM'

const TOGGLE_EDIT = 'offerzen/workHistory/TOGGLE_EDIT'
export const SUBMIT = 'offerzen/workHistory/SUBMIT'

export const SEARCH_COMPANIES = 'offerzen/workHistory/SEARCH_COMPANIES'
const SEARCH_COMPANIES_SUCCESS = 'offerzen/workHistory/SEARCH_COMPANIES_SUCCESS'
const SEARCH_COMPANIES_ERROR = 'offerzen/workHistory/SEARCH_COMPANIES_ERROR'

export const SEARCH_ROLES = 'offerzen/workHistory/SEARCH_ROLES'
const SEARCH_ROLES_SUCCESS = 'offerzen/workHistory/SEARCH_ROLES_SUCCESS'
const SEARCH_ROLES_ERROR = 'offerzen/workHistory/SEARCH_ROLES_ERROR'

// FETCH CREATORS
export const fetchWorkHistory = candidateId => ({
  type: FETCH,
  meta: { candidateId },
})

export const fetchWorkHistorySuccess = data => ({
  type: FETCH_SUCCESS,
  payload: data,
})

export const createWorkHistory = (candidateId, data, resolve, reject) => ({
  type: CREATE,
  meta: { candidateId, data, resolve, reject },
  payload: { loading: true },
})

export const createWorkHistorySuccess = data => ({
  type: CREATE_SUCCESS,
  payload: data,
})

export const createWorkHistoryError = errorMessage => ({
  type: CREATE_ERROR,
  payload: new Error(errorMessage),
})

export const deleteWorkHistory = (candidateId, id) => ({
  type: DELETE,
  meta: { id, candidateId },
})

export const deleteWorkHistorySuccess = id => ({
  type: DELETE_SUCCESS,
  meta: { id },
})

export const deleteWorkHistoryError = errorMessage => ({
  type: DELETE_ERROR,
  payload: new Error(errorMessage),
})

export const updateWorkHistory = (id, data, resolve, reject) => ({
  type: UPDATE,
  meta: { id, data, resolve, reject },
  payload: { loading: true },
})

export const updateWorkHistorySuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    ...data,
    loading: false,
  },
})

export const updateWorkHistoryError = errorMessage => ({
  type: UPDATE_ERROR,
  payload: new Error(errorMessage),
})

/*
 ** `tempId` is used as a unique identifier for new instances of WorkHistoryItemForm,
 ** only records that have not been persisted to the database will use `tempId`, those
 ** that have will use an `id` instead
 */
export const addBlankWorkHistoryItem = tempId => ({
  type: ADD_TEMP_ITEM,
  payload: {
    tempId,
    editing: true,
    isNew: true,
  },
})

export const deleteBlankWorkHistoryItem = tempId => ({
  type: DELETE_TEMP_ITEM,
  meta: { tempId },
})

export const toggleWorkHistoryEdit = (id, editing) => ({
  type: TOGGLE_EDIT,
  payload: { id, editing },
})

export const submit = (data, resolve, reject) => ({
  type: SUBMIT,
  meta: { resolve, reject },
  payload: { data },
})

export const searchCompanies = (id, term) => ({
  type: SEARCH_COMPANIES,
  meta: { term },
  payload: {
    searchingCompanies: true,
    searchCompaniesError: null,
    id,
  },
})

export const searchCompaniesSuccess = (id, data) => ({
  type: SEARCH_COMPANIES_SUCCESS,
  payload: {
    searchingCompanies: false,
    companiesSearchResults: data,
    id,
  },
})

export const searchCompaniesError = errorMessage => ({
  type: SEARCH_COMPANIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchRoles = (id, term) => ({
  type: SEARCH_ROLES,
  meta: { term },
  payload: {
    searchingRoles: true,
    searchRolesError: null,
    id,
  },
})

export const searchRolesSuccess = (id, data) => ({
  type: SEARCH_ROLES_SUCCESS,
  payload: {
    searchingRoles: false,
    rolesSearchResults: data,
    id,
  },
})

export const searchRolesError = errorMessage => ({
  type: SEARCH_ROLES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// REDUCERS
const initialWorkHistory = {
  loading: false,
  editing: false,
  isNew: false,

  searchingCompanies: false,
  searchCompaniesError: null,
  companiesSearchResults: [],

  company: '',
  position: '',

  searchingRoles: false,
  searchRolesError: null,
  rolesSearchResults: [],
}

const workHistory = (state = initialWorkHistory, { type, payload } = {}) => {
  switch (type) {
    case ADD_TEMP_ITEM:
    case CREATE_SUCCESS:
      return {
        ...state,
        ...payload,
      }

    case UPDATE:
    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
      if (state.id !== payload.id) return state

      return {
        ...state,
        ...payload,
      }

    case SEARCH_COMPANIES:
    case SEARCH_ROLES:
    case SEARCH_COMPANIES_SUCCESS:
    case SEARCH_ROLES_SUCCESS:
      const itemId = state.id || state.tempId
      if (itemId !== payload.id) return state

      return {
        ...state,
        ...payload,
      }

    case SEARCH_COMPANIES_ERROR:
      return {
        ...state,
        searchingCompanies: false,
        searchCompaniesError: payload,
      }

    case SEARCH_ROLES_ERROR:
      return { ...state, searchingRoles: false, searchRolesError: payload }

    default:
      return {
        ...initialWorkHistory,
        ...state,
      }
  }
}

const initialState = {
  data: [],
  fetching: true,
  error: null,
}

const entities = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return {
        ...state,
        data: [...state.data, workHistory(undefined, action)],
      }

    case DELETE_TEMP_ITEM:
      return {
        ...state,
        data: state.data.filter(history => history.tempId !== action.meta.tempId),
      }

    case DELETE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(history => history.id !== action.meta.id),
      }

    case FETCH_SUCCESS:
      return {
        fetching: false,
        data: action.payload.map(history => workHistory(history, action)),
      }

    case UPDATE:
    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
    case SEARCH_COMPANIES:
    case SEARCH_COMPANIES_SUCCESS:
    case SEARCH_COMPANIES_ERROR:
    case SEARCH_ROLES:
    case SEARCH_ROLES_SUCCESS:
    case SEARCH_ROLES_ERROR:
      return {
        ...state,
        data: state.data.map(history => workHistory(history, action)),
      }

    default:
      return state
  }
}

export default entities

export const getWorkHistory = state => state.workHistory || initialState
